module.exports = __webpack_public_path__ + "img/our-fleet.5a53508e.webp";